export default __webpack_public_path__ + "static/media/react.ee5e4a8f.svg";